export const INJECT_SYMBOLS = {
  CollectionsQueryGatewayInterface: Symbol.for("CollectionsQueryGatewayInterface"),
  ItemsWriteGatewayInterface: Symbol.for("ItemsWriteGatewayInterface"),
  ItemCommitWorkInterface: Symbol.for("ItemCommitWorkInterface"),
  ItemRevisionQueryGatewayInterface: Symbol.for("ItemRevisionQueryGatewayInterface"),
  CommentsDataGatewayInterface: Symbol.for("CommentsDataGatewayInterface"),
  DatastudioGraphqlClient: Symbol.for("DatastudioGraphqlClient"),
  UsersGatewayInterface: Symbol.for("UsersGatewayInterface"),
  LayoutPresetsDataGatewayInterface: Symbol.for("LayoutPresetsDataGatewayInterface"),
  FeaturesRepositoryInterface: Symbol.for("FeaturesRepositoryInterface"),
  StorageRelationsCache: Symbol.for("StorageRelationsCache"),
  AppEventBus: Symbol.for("AppEventBus"),
  DatastudioRestClient: Symbol.for("DatastudioRestClient"),
  RelationsGateway: Symbol.for("RelationsGateway"),
  PortalMenuGateway: Symbol.for("PortalMenuGateway"),
  LayoutPresetsMapper: Symbol.for("LayoutPresetsMapper"),
  PermissionsMapperInterface: Symbol.for("PermissionsMapperInterface"),
  PermissionsGatewayInterface: Symbol.for("PermissionsGatewayInterface"),
  Logger: Symbol.for("Logger"),
  RolesGatewayInterface: Symbol.for("RolesGatewayInterface"),
  ItemReactionsController: Symbol.for("ItemReactionsController"),
  StorageAuthDriver: Symbol.for("StorageAuthDriver"),
  AuthGatewayInterface: Symbol.for("AuthGatewayInterface"),
  AuthByPhoneServiceInterface: Symbol.for("AuthByPhoneServiceInterface"),
};

